<template>
  <div class="col-sm-12">
    <div class="card">
      <div class="dropdown-container mb-2">
        <div class="dropdown-item" style="flex: 1;">
          <label for="dealerType">Dealer Type</label>
          <select id="dealerType" v-model="selectedDealerType">
            <option :value="null" disabled>Select Type</option>
            <option :value="2">Individual</option>
            <option :value="1">Group</option>
          </select>
        </div>

        <!-- Individual: Route + Dealer dropdowns -->
        <template v-if="selectedDealerType === 2">
          <!--searchable route list dropdown-->
          <div class="dropdown-item" style="flex: 1;">
            <label for="route">Route</label>
            <select id="route" v-model="selectedRoute">
              <option
                v-for="option in multiselectOptionRoute"
                :key="option.route_id"
                :value="option"
              >
                {{ option.route_name }}
              </option>
            </select>
          </div>

          <!--searchable dealer dropdown-->
          <div class="dropdown-item" style="flex: 1;">
            <label for="dealer">Dealer</label>
            <select id="dealer" v-model="selectedDealer">
              <option
                v-for="option in multiselectOptionDealer"
                :key="option.profile_id"
                :value="option"
              >
                {{ option.business_display_name }}
              </option>
            </select>
          </div>
        </template>

        <!-- Group: Dealer Group dropdown -->
        <template v-if="selectedDealerType === 1">
          <div class="dropdown-item" style="flex: 1;">
            <label for="dealerGroup">Dealer Group</label>
            <select id="dealerGroup" v-model="selectedDealerGroup">
              <option
                v-for="option in multiselectOptionDealerGroup"
                :key="option.group_id"
                :value="option"
                :disabled="option.group_id === ''"
              >
                {{ option.group_name }}
              </option>
            </select>
          </div>

          <!--searchable dealer dropdown-->
          <div class="dropdown-item" style="flex: 1;">
            <label for="dealer">Dealer(Optional)</label>
            <select id="dealer" v-model="selectedDealer">
              <option
                v-for="option in multiselectOptionDealer"
                :key="option.profile_id"
                :value="option"
              >
                {{ option.business_display_name }}
              </option>
            </select>
          </div>
        </template>
      </div>

      <div class="dropdown-container">
        <!--start date selection-->
        <div class="dropdown-item" style="flex: 1;">
          <label for="fromDate">From Date</label>
          <input
            type="date"
            v-model="from_date"
            class="search-input"
            :max="currentDate"
            style="width: 100%;"
          />
        </div>

        <!--end date selection-->
        <div class="dropdown-item" style="flex: 1;">
          <label for="todate">To Date</label>
          <input
            type="date"
            v-model="to_date"
            class="search-input"
            :max="currentDate"
            style="width: 100%;"
          />
        </div>

        <!--search button-->
        <div class="dropdown-item search-container" style="flex: 1;">
          <button @click="performSearch" class="btn button-default mt-4" style="width: 100%;">
            Search
          </button>
        </div>
      </div>

      <!-- Loading Spinner -->
      <div v-if="loading" class="loading-spinner">
        <i class="fa fa-spinner fa-spin"></i> Loading...
      </div>

      <!--Table for invoice Payments-->
      <div v-if="searchPerformed && !loading" class="table-responsive">
        <div class="financial-summary-grid d-flex mb-3 gap-3">
          <!--show total due payment-->
          <div class="financial-summary-card summary-due">
            <div class="summary-card-heading">
              <div class="summary-icon">
                <i class="fa fa-exclamation-circle"></i>
              </div>
              <span class="summary-label">Total Due Payments</span>
            </div>
            <div class="summary-value">
              <small>Rs.</small>
              <strong>{{ formatNumber(total_due_amount) }}</strong>
            </div>
          </div>

          <!--show total excess amount-->
          <div class="financial-summary-card summary-paid">
            <div class="summary-card-heading">
              <div class="summary-icon">
                <i class="fa fa-check-circle"></i>
              </div>
              <span class="summary-label">Total Advance Payment</span>
            </div>
            <div class="summary-value">
              <small>Rs.</small>
              <strong>{{ formatNumber(total_excess_amount) }}</strong>
            </div>
          </div>
        </div>

        <!--tabs for invoices & invoice payments-->
<!-- Header Row: Tabs on the left, Action Switch on the right -->
        <div class="d-flex justify-content-between align-items-center mb-4">
          
          <!-- Tabs for Invoices, Payments, Advance Payments -->
          <div class="chip-container mb-0">
            <button
              class="chip chip-blue"
              :class="{ active: selectedTab === 'invoices' }"
              @click="selectedTab = 'invoices'"
            >
              Invoices
              <span class="chip-badge" v-if="filteredInvoices.length > 0">{{ filteredInvoices.length > 99 ? '99+' : filteredInvoices.length }}</span>
            </button>
            
            <button
              class="chip chip-amber"
              :class="{ active: selectedTab === 'payments' }"
              @click="selectedTab = 'payments'"
            >
              Payments
              <span class="chip-badge" v-if="filteredPayments.length > 0">{{ filteredPayments.length > 99 ? '99+' : filteredPayments.length }}</span>
            </button>
            
            <button
              class="chip chip-green"
              :class="{ active: selectedTab === 'AdvancePayments' }"
              @click="selectedTab = 'AdvancePayments'"
            >
              Advance Payments
              <span class="chip-badge" v-if="filteredAdvPayments.length > 0">{{ filteredAdvPayments.length > 99 ? '99+' : filteredAdvPayments.length }}</span>
            </button>
          </div>

          <!-- Action Switch (Payment / Print) - Visible ONLY on Invoices tab -->
          <div class="invoice-action-switch" v-if="selectedTab === 'invoices'">
            <button
              type="button"
              class="invoice-action-btn payment-btn"
              :class="{ active: invoiceActionMode === 'payment' }"
              @click="invoiceActionMode = 'payment'"
            >
              <span class="action-icon">💳</span>
              <span>Payment</span>
            </button>

            <button
              type="button"
              class="invoice-action-btn print-btn"
              :class="{ active: invoiceActionMode === 'print' }"
              @click="invoiceActionMode = 'print'"
            >
              <span class="action-icon">🖨️</span>
              <span>Print</span>
            </button>
          </div>

        </div>

        <!--show content of invoices tab-->
        <div class="tab-content" v-if="selectedTab === 'invoices'">


          <template v-if="invoicePaymentList.length > 0">
          <!--search input-->
          <div class="modern-searchbar-container my-3">
             <div class="modern-searchbar searchbar-blue">
               <i class="fa fa-search search-icon"></i>
               <input
                 type="text"
                 placeholder="Search Invoice No, Dealer or Customer name..."
                 class="modern-search-input"
                 v-model="searchFilter"
               />
             </div>
           </div>

           <template v-if="filteredInvoices.length > 0">
           <template v-if="selectedDealerType === 1">
            <!-- Select All Due bar -->
            <div
              class="d-flex justify-content-between align-items-center px-3 py-2 mb-3"
              style="
                background: #f9f9f7;
                border-radius: 6px;
                border: 1px solid #d3d1c7;
              "
            >
              <div class="d-flex align-items-center gap-2">
                <input
                  type="checkbox"
                  class="checkbox"
                  :checked="allDueSelected"
                  @change="toggleSelectAllDue"
                />
                <span style="font-size: 0.9rem; font-weight: 500"
                  >Select All</span
                >
                <span v-if="invoiceActionMode === 'payment'" class="text-muted" style="font-size: 0.8rem">
                  ({{
                    filteredInvoices.filter(
                      (inv) => parseFloat(inv.due_amount) > 0,
                    ).length
                  }}
                  due invoices · {{ groupedInvoicesByDealer.length }} dealers)
                </span>
              </div>
              <div style="font-size: 0.85rem">
                <span class="text-muted"
                  >{{ selectedInvoices.length }} selected ·
                </span>
                <strong v-if="invoiceActionMode === 'payment'" class="text-primary"
                  >Rs. {{ formatNumber(totalSelectedDueAmount) }}</strong
                >
              </div>
            </div>

            <!-- Accordion dealer list -->
            <div
              v-for="{
                dealerName,
                dealerId,
                invoices,
              } in groupedInvoicesByDealer"
              :key="dealerId"
              class="mb-2"
            >
              <!-- Dealer bar (clickable) -->
              <div
                class="dealer-group-header d-flex align-items-center justify-content-between px-3 py-2"
                style="
                  cursor: pointer;
                  border-radius: 6px;
                  border: 1px solid #b5d4f4;
                  background: #e6f1fb;
                  border-left: 4px solid #378add;
                "
                @click="toggleDealerExpand(dealerId)"
              >
                <div class="d-flex align-items-center gap-2">
                  <!-- Per-dealer select-all checkbox (stops click propagating to accordion toggle) -->
                  <input
                    type="checkbox"
                    class="checkbox"
                    :checked="isDealerAllSelected(invoices)"
                    @change="toggleDealerSelection(invoices)"
                    @click.stop
                  />
                  <strong>{{ dealerName }}</strong>
                  <span class="text-muted ms-2" style="font-size: 0.85rem">
                    {{ invoices.length }} invoice(s) ·
                    {{
                      invoices.filter((inv) => parseFloat(inv.due_amount) > 0)
                        .length
                    }}
                    due ·
                    <span class="text-danger"
                      >Rs. {{ formatNumber(dealerTotalDue(invoices)) }}</span
                    >
                  </span>
                </div>

                <!-- Expand/collapse icon -->
                <i
                  :class="
                    expandedDealers[dealerId]
                      ? 'fa fa-chevron-up'
                      : 'fa fa-chevron-down'
                  "
                  style="font-size: 0.85rem; color: #888"
                ></i>
              </div>

              <!-- Invoice table — shown only when expanded -->
              <div v-if="expandedDealers[dealerId]" class="table-scroll-container mb-3">
                <table class="table table-compact mb-0" style="border-top: none">
                  <thead>
                    <tr>
                      <th></th>
                      <th scope="col">
                        Invoice No | Date
                        <i
                          class="fa fa-info-circle info-icon"
                          @click.stop="toggleInfoTooltip"
                          title="Click for details"
                        ></i>
                      </th>
                      <th scope="col">
                        {{
                          isCashSaleDealer(dealerName) ? "Customer" : "Dealer"
                        }}
                      </th>
                      <th scope="col">Total (Rs)</th>
                      <th scope="col">Paid (Rs)</th>
                      <th scope="col">Due (Rs)</th>
                      <th scope="col">Status</th>
                      <th scope="col">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="invoice in invoices" :key="invoice.invoices_no">
                      <td>
                        <input
                          type="checkbox"
                          class="checkbox"
                          :value="invoice"
                          v-model="selectedInvoices"
                          :disabled="invoiceActionMode === 'payment' && parseFloat(invoice.due_amount) <= 0"
                        />
                      </td>
                      <td style="line-height: 1.2; font-size: 0.85rem">
                        <div class="d-inline-flex align-items-center gap-1">
                          <span>{{ invoice.invoices_no }}</span>
                          <i
                            v-if="invoice.vat_liable == 1 || invoice.vat_liable === '1' || invoice.vat_liable === true"
                            class="fa fa-check-circle vat-verification-badge"
                            title="Tax Invoice"
                          ></i>
                        </div>
                        <div>{{ invoice.invoice_created_at }}</div>
                      </td>
                      <td style="font-size: 0.85rem">
                        <span v-if="isCashSaleDealer(invoice)">
                          {{ invoice.customer_name || invoice.customer || "—" }}
                        </span>
                        <span v-else>
                          {{
                            invoice.business_name ||
                            invoice.business_display_name ||
                            "—"
                          }}
                        </span>
                      </td>
                      <td>{{ formatNumber(invoice.net_total) }}</td>
                      <td>{{ formatNumber(invoice.total_paid) }}</td>
                      <td style="color: red">
                        {{ formatNumber(invoice.due_amount) }}
                      </td>
                      <td>
                        <span
                          :class="{
                            'status-label status-pending':
                              String(invoice.invoice_status ?? '1') === '1',
                            'status-label status-completed':
                              String(invoice.invoice_status ?? '1') === '2',
                            'status-label status-cancelled':
                              String(invoice.invoice_status ?? '1') === '3',
                            'status-label status-redeemed':
                              String(invoice.invoice_status ?? '1') === '4',
                          }"
                          >{{ ShowStatus(invoice.invoice_status ?? "1") }}</span
                        >
                      </td>
                      <td>
                        <i
                          class="fa fa-eye action-icon"
                          @click="showInvoiceDetails(invoice.invoices_no)"
                        ></i>
                        <i
                          v-if="invoiceActionMode === 'payment'"
                          class="fa fa-edit action-icon ms-2"
                          @click="
                            editInvoicePaymentDetails(invoice.invoices_no)
                          "
                        ></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </template>

          <!-- Individual mode invoice table -->
          <template v-else>
            <!-- Select All Due bar -->
            <div
              class="d-flex justify-content-between align-items-center px-3 py-2 mb-3"
              style="
                background: #f9f9f7;
                border-radius: 6px;
                border: 1px solid #d3d1c7;
              "
            >
              <div class="d-flex align-items-center gap-2">
                <input
                  type="checkbox"
                  class="checkbox"
                  :checked="allDueSelected"
                  @change="toggleSelectAllDue"
                />
                <span style="font-size: 0.9rem; font-weight: 500">Select All</span>
                <span v-if="invoiceActionMode === 'payment'" class="text-muted" style="font-size: 0.8rem">
                  ({{
                    filteredInvoices.filter(
                      (inv) => parseFloat(inv.due_amount) > 0,
                    ).length
                  }}
                  due invoices)
                </span>
              </div>
              <div style="font-size: 0.85rem">
                <span class="text-muted"
                  >{{ selectedInvoices.length }} selected ·
                </span>
                <strong v-if="invoiceActionMode === 'payment'" class="text-primary"
                  >Rs. {{ formatNumber(totalSelectedDueAmount) }}</strong
                >
              </div>
            </div>

            <div class="table-scroll-container">
              <table class="table table-compact">
                <thead>
                  <tr>
                    <th></th>
                  <th scope="col">
                    Invoice No | Date
                    <i
                      class="fa fa-info-circle info-icon"
                      @click.stop="toggleInfoTooltip"
                      title="Click for details"
                    ></i>
                  </th>
                  <th scope="col">
                    {{
                      isCashSaleDealer(selectedDealer) ? "Customer" : "Dealer"
                    }}
                  </th>
                  <th scope="col">Total (Rs)</th>
                  <th scope="col">Paid (Rs)</th>
                  <th scope="col">Due (Rs)</th>
                  <th scope="col">Status</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="invoice in filteredInvoices"
                  :key="invoice.invoices_no"
                >
                  <td>
                    <input
                      type="checkbox"
                      class="checkbox"
                      :value="invoice"
                      v-model="selectedInvoices"
                      :disabled="invoiceActionMode === 'payment' && parseFloat(invoice.due_amount) <= 0"
                    />
                  </td>
                  <td style="line-height: 1.2; font-size: 0.85rem">
                    <div class="d-inline-flex align-items-center gap-1">
                      <span>{{ invoice.invoices_no }}</span>
                      <i
                        v-if="invoice.vat_liable == 1 || invoice.vat_liable === '1' || invoice.vat_liable === true"
                        class="fa fa-check-circle vat-verification-badge"
                        title="Tax Invoice"
                      ></i>
                    </div>
                    <div>{{ invoice.invoice_created_at }}</div>
                  </td>
                  <td style="font-size: 0.85rem">
                    <span v-if="isCashSaleDealer(invoice)">
                      {{ invoice.customer_name || invoice.customer || "—" }}
                    </span>
                    <span v-else>
                      {{
                        invoice.business_name ||
                        invoice.business_display_name ||
                        "—"
                      }}
                    </span>
                  </td>
                  <td>{{ formatNumber(invoice.net_total) }}</td>
                  <td>{{ formatNumber(invoice.total_paid) }}</td>
                  <td style="color: red">
                    {{ formatNumber(invoice.due_amount) }}
                  </td>
                  <td>
                    <span
                      :class="{
                        'status-label status-pending':
                          String(invoice.invoice_status ?? '1') === '1',
                        'status-label status-completed':
                          String(invoice.invoice_status ?? '1') === '2',
                        'status-label status-cancelled':
                          String(invoice.invoice_status ?? '1') === '3',
                        'status-label status-redeemed':
                          String(invoice.invoice_status ?? '1') === '4',
                      }"
                      >{{ ShowStatus(invoice.invoice_status ?? "1") }}</span
                    >
                  </td>
                  <td>
                    <i
                      class="fa fa-eye action-icon"
                      @click="showInvoiceDetails(invoice.invoices_no)"
                    ></i>
                    <i
                      v-if="invoiceActionMode === 'payment'"
                      class="fa fa-edit action-icon ms-2"
                      @click="editInvoicePaymentDetails(invoice.invoices_no)"
                    ></i>
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
          </template>

          <div class="bottom-action-bar">
            <div class="info-section">
              <span class="info-label text-primary">Selected Due</span>
              <span class="info-value">Rs. {{ formatNumber(totalSelectedDueAmount) }}</span>
            </div>
            <div>
              <button
                v-if="invoiceActionMode === 'payment'"
                type="button"
                class="btn button-default btn-action"
                @click="handleProceedToPayment"
                :disabled="!canProceedToPayment || totalSelectedDueAmount <= 0"
              >
                Proceed to Payment
              </button>

              <button
                v-else
                type="button"
                class="btn button-default btn-action"
                @click="handlePrintInvoices"
                :disabled="selectedInvoices.length === 0"
              >
                Print
              </button>
            </div>
          </div>
          </template>
          <div v-else class="modern-empty-state">
            <i class="fa fa-search empty-icon"></i>
            <h5>No Results Found</h5>
            <p>We couldn't find any invoices matching your search.</p>
          </div>
          </template>
          <div v-else class="modern-empty-state">
            <i class="fa fa-file-invoice empty-icon"></i>
            <h5>No Invoices Available</h5>
            <p>There are currently no invoices to display.</p>
          </div>
        </div>

        <!--show content of payments tab-->
        <div class="tab-content" v-if="selectedTab === 'payments'">
          <template v-if="flattenedPayments.length > 0">
          <!--search input-->
          <div class="modern-searchbar-container my-3">
            <div class="modern-searchbar searchbar-amber">
              <i class="fa fa-search search-icon"></i>
              <input
                type="text"
                placeholder="Search invoice, cheque no, status, amount..."
                class="modern-search-input"
                v-model="searchPayments"
              />
            </div>
          </div>

          <!--payment details table-->
          <template v-if="filteredPayments.length > 0">
          <div class="table-scroll-container mb-3">
            <table class="table table-compact">
              <thead>
                <tr class="border-bottom-primary">
                  <th scope="col">
                    <input
                      type="checkbox"
                      class="checkbox"
                      :checked="allVisiblePaymentsSelected"
                      @change="toggleVisiblePaymentSelection"
                    />
                  </th>
                  <th scope="col">Invoice No</th>
                  <th scope="col">Payment Method</th>
                  <th scope="col">Amount (Rs)</th>
                  <th scope="col">Paid At</th>
                  <th scope="col">Status</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(payment, index) in filteredPayments" :key="index">
                  <td :class="{ 'highlight-row': payment.flag === 1 }">
                    <input
                      type="checkbox"
                      class="checkbox"
                      :value="String(payment.payment_id)"
                      v-model="selectedPaymentIds"
                      :disabled="!isPaymentCancellable(payment)"
                    />
                  </td>

                  <td :class="{ 'highlight-row': payment.flag === 1 }">
                    {{ payment.invoice_no }}
                  </td>
                  <td :class="{ 'highlight-row': payment.flag === 1 }">
                    <div>{{ payment.payment_method }}</div>
                    <div v-if="payment.payment_method === 'Cheque' && payment.cheque_no">
                      <small>(No: {{ payment.cheque_no }})</small>
                    </div>
                    <div v-if="payment.payment_method === 'Bank Transfer' && payment.bank_acc_no">
                      <small>(A/C No: {{ payment.bank_acc_no }})</small>
                    </div>
                    <div v-if="payment.payment_method === 'Advance' && payment.advance_pay_method">
                      <small>({{ payment.advance_pay_method }} - {{ formatNumber(payment.advance_amount) }})</small>
                    </div>
                    <div v-if="payment.payment_method === 'Credit/Debit Card' && payment.card_type">
                      <small>({{ payment.card_type }} - ****{{ payment.card_last4_digits }})</small>
                    </div>
                    <div v-if="payment.payment_method === 'Mobile Payment' && payment.mobile_payment_type">
                      <small>({{ payment.mobile_payment_type }} - {{ payment.mobile_provider }})</small>
                    </div>
                    <div v-if="payment.payment_method === 'Online Payment' && payment.online_gateway">
                      <small>(Gateway: {{ payment.online_gateway }})</small>
                    </div>
                  </td>
                  <td :class="{ 'highlight-row': payment.flag === 1 }">
                    {{ formatNumber(payment.amount) }}
                  </td>
                  <td :class="{ 'highlight-row': payment.flag === 1 }">
                    {{ formatDateTime(payment.paid_at) }}
                  </td>
                  <td :class="{ 'highlight-row': payment.flag === 1 }">
                    <select
                      v-if="editingRowIndex === index"
                      id="status"
                      v-model="payment.status"
                      class="scrollable-dropdown"
                    >
                      <option disabled value="">Select Status</option>
                      <option
                        v-for="status in statusList"
                        :key="status.id"
                        :value="status.id"
                      >
                        {{ status.name }}
                      </option>
                    </select>

                    <span
                      v-else
                      :class="{
                        'status-label status-pending': payment.status === '1',
                        'status-label status-completed': payment.status === '2',
                        'status-label status-cancelled': payment.status === '3',
                        'status-label status-redeemed': payment.status === '4',
                      }"
                    >
                      {{ ShowStatus(payment.status) }}
                    </span>
                  </td>

                  <td :class="{ 'highlight-row': payment.flag === 1 }">
                    <div>
                      <div class="d-flex justify-content-between align-items-center">
                        <div v-if="editingRowIndex !== index">
                          <i
                            class="fa fa-edit action-icon m-r-5"
                            :class="{
                              'disabled-icon': payment.status !== '1'
                            }"
                            :style="{
                              pointerEvents: payment.status !== '1' ? 'none' : 'auto'
                            }"
                            @click="editDetails(index)"
                          ></i>
                          <i
                            class="fa fa-times-circle-o action-icon m-r-5"
                            :class="{ 'disabled-icon': payment.status === '3' }"
                            :style="{
                              pointerEvents:
                                payment.status === '3' ? 'none' : 'auto',
                            }"
                            @click="openCancelPopup(payment.payment_id, index)"
                          ></i>
                        </div>

                        <div v-if="editingRowIndex === index" class="d-flex gap-2">
                          <button
                            @click="saveDetails(payment.payment_id, index)"
                            :disabled="saveButtonDisabled"
                            class="btn btn-action-accept"
                            title="Accept"
                          >
                            <span
                              v-if="saveButtonDisabled"
                              class="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            <span v-else><i class="fa-solid fa-check"></i></span>
                          </button>
                          <button @click="cancelEdit()" class="btn btn-action-close" title="Close">
                            <i class="fa-solid fa-xmark"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="bottom-action-bar">
            <div class="info-section">
              <span class="info-label">Payments Selected</span>
              <span class="info-value">{{ selectedPaymentsCount }}</span>
            </div>
            <div>
              <button
                type="button"
                class="btn btn-danger btn-action"
                @click="openBulkPaymentCancelPopup('selected')"
                :disabled="selectedPaymentsCount === 0"
              >
                Cancel Selected
              </button>
            </div>
          </div>
          </template>
          <div v-else class="modern-empty-state">
            <i class="fa fa-search empty-icon"></i>
            <h5>No Results Found</h5>
            <p>We couldn't find any invoice payments matching your search.</p>
          </div>
          </template>
          <div v-else class="modern-empty-state">
            <i class="fa fa-money-bill-wave empty-icon"></i>
            <h5>No Payments Found</h5>
            <p>There are currently no invoice payments to display.</p>
          </div>
        </div>

        <!--show content of advance payments tab-->
        <div class="tab-content" v-if="selectedTab === 'AdvancePayments'">
          <template v-if="advancePaymentList.length > 0">
          <!--search input-->
          <div class="modern-searchbar-container my-3">
            <div class="modern-searchbar searchbar-green">
              <i class="fa fa-search search-icon"></i>
              <input
                type="text"
                placeholder="Search cheque no, status, amount..."
                class="modern-search-input"
                v-model="searchAdvPayments"
              />
            </div>
          </div>

          <!--Advance payment details table-->
          <template v-if="filteredAdvPayments.length > 0">
          <div class="table-scroll-container mb-3">
            <table class="table table-compact">
              <thead>
                <tr>
                <th scope="col">Payment Method</th>
                <th scope="col">Dealer</th>
                <th scope="col">Amount (Rs)</th>
                <th scope="col">Balance (Rs)</th>
                <th scope="col">Paid At</th>
                <th scope="col">Status</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(ad_payment, index) in filteredAdvPayments"
                :key="index"
              >
                <td>
                  <div>{{ ad_payment.pay_method || ad_payment.ad_pay_method }}</div>
                  <div v-if="(ad_payment.pay_method === 'Cheque' || ad_payment.ad_pay_method === 'Cheque') && (ad_payment.cheque_no || ad_payment.ad_cheque_no)">
                    <small>(No: {{ ad_payment.cheque_no || ad_payment.ad_cheque_no }})</small>
                  </div>
                  <div v-if="(ad_payment.pay_method === 'Bank Transfer' || ad_payment.ad_pay_method === 'Bank Transfer') && (ad_payment.bank_acc_no || ad_payment.ad_bank_acc_no)">
                    <small>(A/C No: {{ ad_payment.bank_acc_no || ad_payment.ad_bank_acc_no }})</small>
                  </div>
                  <div v-if="(ad_payment.pay_method === 'Credit/Debit Card' || ad_payment.ad_pay_method === 'Credit/Debit Card') && (ad_payment.card_type || ad_payment.ad_card_type)">
                    <small>({{ ad_payment.card_type || ad_payment.ad_card_type }} - ****{{ ad_payment.card_last4_digits || ad_payment.ad_card_last4_digits }})</small>
                  </div>
                  <div v-if="(ad_payment.pay_method === 'Mobile Payment' || ad_payment.ad_pay_method === 'Mobile Payment') && (ad_payment.mobile_payment_type || ad_payment.ad_mobile_payment_type)">
                    <small>({{ ad_payment.mobile_payment_type || ad_payment.ad_mobile_payment_type }} - {{ ad_payment.mobile_provider || ad_payment.ad_mobile_provider }})</small>
                  </div>
                  <div v-if="(ad_payment.pay_method === 'Online Payment' || ad_payment.ad_pay_method === 'Online Payment') && (ad_payment.online_gateway || ad_payment.ad_online_gateway)">
                    <small>(Gateway: {{ ad_payment.online_gateway || ad_payment.ad_online_gateway }})</small>
                  </div>
                </td>
                <td>{{ ad_payment.ad_business_name }}</td>
                <td>{{ formatNumber(ad_payment.advance_amount) }}</td>
                <td>{{ formatNumber(ad_payment.advance_balance) }}</td>
                <td>{{ formatDateTime(ad_payment.ad_paid_at) }}</td>
                <td>
                  <select
                    v-if="editingAdvRowIndex === index"
                    id="adv-status"
                    v-model="ad_payment.ad_status"
                    class="scrollable-dropdown"
                  >
                    <option disabled value="">Select Status</option>
                    <option
                      v-for="status in statusList"
                      :key="status.id"
                      :value="status.id"
                    >
                      {{ status.name }}
                    </option>
                  </select>

                  <span
                    v-else
                    :class="{
                      'status-label status-pending':
                        ad_payment.ad_status === '1',
                      'status-label status-completed':
                        ad_payment.ad_status === '2',
                      'status-label status-cancelled':
                        ad_payment.ad_status === '3',
                      'status-label status-redeemed':
                        ad_payment.ad_status === '4',
                    }"
                  >
                    {{ ShowStatus(ad_payment.ad_status) }}
                  </span>
                </td>
                <td>
                  <div class="d-flex justify-content-between align-items-center">
                    <div v-if="editingAdvRowIndex !== index" class="d-flex align-items-center">
                      <i
                        class="fa fa-edit action-icon m-r-5"
                        :class="{
                          'disabled-icon':
                            ad_payment.ad_status !== '1' ||
                            ad_payment.ad_pay_method === 'Cash',
                        }"
                        :style="{
                          pointerEvents:
                            ad_payment.ad_status !== '1' ||
                            ad_payment.ad_pay_method === 'Cash'
                              ? 'none'
                              : 'auto',
                        }"
                        @click="editAdDetails(index)"
                      >
                      </i>

                      <!-- Details Print -->
                      <i
                        class="fa fa-print action-icon m-r-5"
                        title="Print Advance Payment Details"
                        @click="openAdvancePaymentPrint(ad_payment)"
                      ></i>

                      <!-- Delete (disabled for Cash method / non-pending) -->
                      <i
                        class="fa fa-edit action-icon m-r-5"
                        :class="{
                          'disabled-icon': ad_payment.ad_status !== '1'
                        }"
                        :style="{
                          pointerEvents: ad_payment.ad_status !== '1' ? 'none' : 'auto'
                        }"
                        @click="editAdDetails(index)"
                      ></i>

                      <!-- Cancel -->
                      <i
                        class="fa fa-times-circle-o action-icon m-r-5"
                        :class="{
                          'disabled-icon':
                            ad_payment.ad_status === '3' ||
                            hasBeenUsed(ad_payment),
                        }"
                        :style="{
                          pointerEvents:
                            ad_payment.ad_status === '3' ||
                            hasBeenUsed(ad_payment)
                              ? 'none'
                              : 'auto',
                        }"
                        :title="
                          hasBeenUsed(ad_payment)
                            ? 'Cannot cancel: advance has been applied to invoice payments'
                            : 'Cancel'
                        "
                        @click="
                          openCancelPopupADPayments(
                            ad_payment.advance_payment_id,
                            index,
                          )
                        "
                      ></i>
                    </div>

                    <div v-if="editingAdvRowIndex === index" class="d-flex gap-2">
                      <button
                        @click="
                          saveADPaymentDetails(
                            ad_payment.advance_payment_id,
                            index,
                          )
                        "
                        :disabled="saveAdvButtonDisabled"
                        class="btn btn-action-accept"
                        title="Accept"
                      >
                        <span
                          v-if="saveAdvButtonDisabled"
                          class="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        <span v-else><i class="fa-solid fa-check"></i></span>
                      </button>
                      <button @click="cancelAdvEdit()" class="btn btn-action-close" title="Close">
                        <i class="fa-solid fa-xmark"></i>
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          </div>



          <div class="bottom-action-bar justify-content-end">
            <div
              :style="{
                cursor: !selectedDealer.profile_id ? 'not-allowed' : 'pointer',
              }"
            >
              <button
                type="button"
                class="btn button-default btn-action"
                @click="newAdvance"
                :disabled="!selectedDealer.profile_id"
              >
                New Advance Payment
              </button>
            </div>
          </div>
          </template>
          <div v-else class="modern-empty-state">
            <i class="fa fa-search empty-icon"></i>
            <h5>No Results Found</h5>
            <p>We couldn't find any advance payments matching your search.</p>
          </div>
          </template>
          <div v-else class="modern-empty-state">
            <i class="fa fa-hand-holding-dollar empty-icon"></i>
            <h5>No Advance Payments</h5>
            <p v-if="selectedDealer && selectedDealer.profile_id">There are currently no advance payments. <a href="#" @click.prevent="newAdvance" class="add-link">Click here to add one.</a></p>
            <p v-else>There are currently no advance payments. Please select a dealer to add one.</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Bottom Sheet for Cancel Invoice payment -->
  <div
    v-if="showBottomSheet"
    class="bottom-sheet-overlay"
    @click="showBottomSheet = false"
  >
    <div class="bottom-sheet" @click.stop>
      <h3>Cancel Invoice Payment</h3>
      <label>Remark:</label>
      <textarea
        v-model="cancelRemark"
        class="bottom-sheet-textarea"
        :class="{ 'border-red': remarkError }"
        placeholder="Add your remark here..."
        maxlength="200"
        @input="validateRemark"
      ></textarea>

      <!-- Error Message -->
      <p v-if="remarkError" class="error-message">Please add a remark.</p>

      <!-- Character Counter -->
      <div class="character-counter">{{ cancelRemark.length }}/200</div>

      <div class="bottom-sheet-actions">
        <button @click="closeBottomSheet" class="btn-exit">Exit</button>
        <button
          @click="confirmCancel(selectedInvoiceId)"
          class="btn-cancel"
          :disabled="loading"
        >
          <span
            v-if="loading"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          <span v-else>Cancel Invoice Payment</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Bottom Sheet for Bulk Cancel Invoice Payments -->
  <div
    v-if="showBulkPaymentCancelSheet"
    class="bottom-sheet-overlay"
    @click="closeBulkPaymentCancelSheet"
  >
    <div class="bottom-sheet" @click.stop>
      <!-- <h3>
        {{
          bulkPaymentCancelMode === "all"
            ? "Cancel All Invoice Payments"
            : "Cancel Selected Invoice Payments"
        }}
      </h3> -->
      <h3>Cancel Selected Invoice Payments</h3>

      <p style="font-size: 14px; color: #666">
        You are about to cancel
        <strong>{{ bulkPaymentIdsToCancel().length }}</strong>
        invoice payment(s).
      </p>

      <label>Remark:</label>
      <textarea
        v-model="bulkCancelRemark"
        class="bottom-sheet-textarea"
        :class="{ 'border-red': bulkCancelRemarkError }"
        placeholder="Add your remark here..."
        maxlength="200"
        @input="validateBulkCancelRemark"
      ></textarea>

      <p v-if="bulkCancelRemarkError" class="error-message">
        Please add a remark.
      </p>

      <div class="character-counter">{{ bulkCancelRemark.length }}/200</div>

      <div class="bottom-sheet-actions">
        <button @click="closeBulkPaymentCancelSheet" class="btn-exit">
          Exit
        </button>

        <button
          @click="confirmBulkPaymentCancel"
          class="btn-cancel"
          :disabled="bulkCancelLoading"
        >
          <span
            v-if="bulkCancelLoading"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          <span v-else>Cancel Invoice Payments</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Bottom Sheet for Cancel advance payment -->
  <div
    v-if="showADBottomSheet"
    class="bottom-sheet-overlay"
    @click="showADBottomSheet = false"
  >
    <div class="bottom-sheet" @click.stop>
      <h3>Cancel Advance Payment</h3>
      <label>Remark:</label>
      <textarea
        v-model="cancelRemark"
        class="bottom-sheet-textarea"
        :class="{ 'border-red': remarkError }"
        placeholder="Add your remark here..."
        maxlength="200"
        @input="validateRemark"
      ></textarea>

      <!-- Error Message -->
      <p v-if="remarkError" class="error-message">Please add a remark.</p>

      <!-- Character Counter -->
      <div class="character-counter">{{ cancelRemark.length }}/200</div>

      <div class="bottom-sheet-actions">
        <button @click="closeBottomSheet" class="btn-exit">Exit</button>
        <button
          @click="confirmPaymentCancel(selectedPaymentId)"
          class="btn-cancel"
          :disabled="loading"
        >
          <span
            v-if="loading"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          <span v-else>Cancel Advance Payment</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Full Screen Loading Overlay -->
  <div v-if="loadingSettlePopup" class="fullscreen-loader">
    <div class="spinner"></div>
  </div>

  <!-- edit invoice payment-->
  <editinvoicePaymentPopup
    :showEditModal="showEditModal"
    :invoice_no="selectedInvoiceNo"
    @close="closeEditInvoiceModal"
  />

  <!-- new advance payment-->
  <advancePaymentPopup
    :showAdvancePaymentModal="showAdvancePaymentModal"
    :dealer="selectedDealer"
    :excessAmount="total_excess_amount"
    :totalDue="totalSelectedDueAmount"
    @close="closeAdvancePaymentModal"
  />

  <!-- settle invoice due payments-->
  <invoicePaymentSettlePopup
    :showSettleInvoicePaymentModal="showSettleInvoicePaymentModal"
    :dealer="selectedDealer"
    :dealerGroup="selectedDealerGroup"
    :isGroupMode="selectedDealerType === 1"
    :totalExcessAmount="total_excess_amount"
    :totalDue="totalSelectedDueAmount"
    :selectedInvoices="selectedInvoices"
    :loadingSettlePopup="loadingSettlePopup"
    @close="closeSettleInvoicePaymentModal"
  />

  <!--view invoice details-->
  <InvoiceModal
    :showModal="showModal"
    :invoiceNo="selectedInvoiceNo"
    :invoiceNos="selectedInvoiceNos"
    :multipleInvoices="isMultiInvoiceView"
    :allowCancel="invoiceActionMode === 'payment'"
    @close="closeModal"
  />

  <!-- Advance Payment Print Modal -->
  <AdvancePaymentPrintModal
    :showModal="showAdvancePaymentPrintModal"
    :advancePaymentId="selectedAdvancePayment ? selectedAdvancePayment.advance_payment_id : null"
    @close="closeAdvancePaymentPrintModal"
  />

  <!-- Info Tooltip Floating Overlay -->
  <teleport to="body">
    <div
      v-if="showInfoTooltip"
      class="header-info-tooltip"
      :style="{ top: tooltipTop + 'px', left: tooltipLeft + 'px' }"
      @click.stop
    >
      <div class="tooltip-arrow"></div>
      <div class="tooltip-content">
        <span>Invoices marked with <i class="fa fa-check-circle vat-verification-badge-sm"></i> icon represent Tax Invoices.</span>
      </div>
    </div>
  </teleport>
</template>

<script>
import {
  fetchInvoiceDetails,
  fetchRouteListByLoginUser,
  invoicePaymentDetails,
  getDealersByRoute,
  updateInvoicePaymentDetails,
  cancelInvoicePayment,
  getAdvancePaymentDetails,
  cancelAdvancePayment,
  updateAdvancePayment,
  getDealerGroups,
  getDealersByGroup,
  bulkCancelInvoicePayments,
} from "@/services/dataService";
import { useToast } from "vue-toastification";

import editinvoicePaymentPopup from "@/pages/Modal/editinvoicePaymentPopup.vue";
import InvoiceModal from "@/pages/Modal/invoicePopup.vue";
import advancePaymentPopup from "@/pages/Modal/advancePaymentPopup.vue";
import invoicePaymentSettlePopup from "@/pages/Modal/invoicePaymentSettlePopup.vue";
import AdvancePaymentPrintModal from "@/pages/Modal/advancePaymentPrintModal.vue";

export default {
  components: {
    InvoiceModal,
    editinvoicePaymentPopup,
    advancePaymentPopup,
    invoicePaymentSettlePopup,
    AdvancePaymentPrintModal,
  },
  emits: ["close"],
  data() {
    const currentDate = new Date().toISOString().split("T")[0];
    const allRoutesOption = { route_id: "", route_name: "All Routes" };
    const allDealersOption = {
      profile_id: "",
      business_display_name: "All Dealers",
    };
    const allDealerGroupsOption = {
      group_id: "",
      group_name: "Select Dealer Group",
    };
    return {
      token: localStorage.getItem("token_set") || "",
      profileId: localStorage.getItem("profile_id"),
      successmessage: "",
      dealerList: [],
      allRoutesOption,
      allDealersOption,
      allDealerGroupsOption,
      selectedDealer: allDealersOption,
      filteredDealers: [],
      routeList: [],
      selectedRoute: allRoutesOption,
      filteredRoutes: [],
      searchFilter: "",
      searchPayments: "",
      amount: "",
      chequeNo: "",
      refCode: "",
      from_date: currentDate,
      to_date: currentDate,
      loading: false,
      currentDate,
      invoicePaymentList: [],
      advancePaymentList: [],
      currentPage: 1,
      perPage: 10,
      route_id: 0,
      searchPerformed: false,
      selectedPayMethod: "",
      allbankList: [],
      filteredAllBanks: [],
      bankList: [],
      selectedBank: "",
      branchesList: [],
      filteredBranches: [],
      selectedBranch: "",
      selectedInvoices: [],
      showPopup: false,
      loadingPopup: false,
      showConfirmPopup: false,
      total_due_amount: "",
      total_excess_amount: 0,
      totalDueAmount: 0,
      excessAmount: 0,
      saveButtonDisabled: false,
      statusList: [
        { id: "1", name: "Pending" },
        { id: "2", name: "Completed" },
      ],
      showEditModal: false,
      showAdvancePaymentModal: false,
      showSettleInvoicePaymentModal: false,
      selectedInvoiceNo: "",
      selectedInvoiceNos: [],
      isMultiInvoiceView: false,
      showModal: false,
      selectedInvoice: {},
      selectedTab: "invoices",
      invoiceActionMode: "payment",
      rawInvoicePayments: [],
      flattenedPayments: [],
      currentPaymentPage: 1,
      perPaymentPage: 10,
      editingRowIndex: null,
      searchAdvPayments: "",
      currentAdvPaymentPage: 1,
      perAdvPaymentPage: 10,
      editingADPaymentRowIndex: null,
      showBottomSheet: false,
      showADBottomSheet: false,
      cancelRemark: "",
      remarkError: false,
      selectedInvoiceId: "",
      selectedInvoiceIndex: "",
      selectedPaymentId: "",
      selectedPaymentIndex: "",
      selectedPaymentIds: [],
      showBulkPaymentCancelSheet: false,
      bulkPaymentCancelMode: "selected",
      bulkCancelRemark: "",
      bulkCancelRemarkError: false,
      bulkCancelLoading: false,
      loadingSettlePopup: false,
      advancePayments: [],
      showAdvancePaymentPrintModal: false,
      selectedAdvancePayment: null,
      editingAdvRowIndex: null,
      saveAdvButtonDisabled: false,
      selectedDealerType: 2,
      selectedDealerGroup: allDealerGroupsOption,
      dealerGroupList: [],
      filteredDealerGroups: [],
      expandedDealers: {},
      advancePaymentsByDealer: {},
      showInfoTooltip: false,
      tooltipTop: 0,
      tooltipLeft: 0,
    };
  },

  computed: {
    filteredInvoices() {
      if (!this.searchFilter) return this.invoicePaymentList;
      const q = this.searchFilter.toLowerCase();
      return this.invoicePaymentList.filter((invoice) => {
        const invoiceNo = (invoice.invoices_no || "").toLowerCase();
        const businessName = (
          invoice.business_name ||
          invoice.business_display_name ||
          ""
        ).toLowerCase();
        const customerName = (
          invoice.customer_name ||
          invoice.customer ||
          ""
        ).toLowerCase();
        return (
          invoiceNo.includes(q) ||
          businessName.includes(q) ||
          customerName.includes(q)
        );
      });
    },

    paginatedInvoiceList() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredInvoices.slice(start, end);
    },

    totalPages() {
      return Math.ceil(this.filteredInvoices.length / this.perPage) || 1;
    },

    multiselectOptionDealer() {
      return [this.allDealersOption, ...this.filteredDealers];
    },

    multiselectOptionRoute() {
      return [this.allRoutesOption, ...this.filteredRoutes];
    },

    totalSelectedDueAmount() {
      return this.selectedInvoices.reduce(
        (total, inv) => total + parseFloat(inv.due_amount || 0),
        0,
      );
    },

    filteredPayments() {
      const list = Array.isArray(this.flattenedPayments)
        ? this.flattenedPayments
        : [];
      if (!this.searchPayments) return list;
      const statusMap = {
        1: "Pending",
        2: "Completed",
        3: "Cancelled",
        4: "Redeemed",
      };
      const q = this.searchPayments.toLowerCase();
      return list.filter((p) => {
        const statusLabel = statusMap[p.status] || "";
        return (
          (p.invoice_no || "").toLowerCase().includes(q) ||
          statusLabel.toLowerCase().includes(q) ||
          (p.cheque_no || "").toLowerCase().includes(q) ||
          String(p.amount || "").includes(q)
        );
      });
    },

    cancellableFilteredPayments() {
      return this.filteredPayments.filter((payment) =>
        this.isPaymentCancellable(payment),
      );
    },

    cancellablePaginatedPayments() {
      return this.paginatedPayments.filter((payment) =>
        this.isPaymentCancellable(payment),
      );
    },

    allVisiblePaymentsSelected() {
      if (this.cancellablePaginatedPayments.length === 0) return false;

      const selectedIds = new Set(this.selectedPaymentIds.map(String));

      return this.cancellablePaginatedPayments.every((payment) =>
        selectedIds.has(String(payment.payment_id)),
      );
    },

    selectedPaymentsCount() {
      return this.selectedPaymentIds.length;
    },

    filteredAdvPayments() {
      const list = Array.isArray(this.advancePaymentList)
        ? this.advancePaymentList
        : [];
      if (!this.searchAdvPayments) return list;
      const statusMap = {
        1: "Pending",
        2: "Completed",
        3: "Cancelled",
        4: "Redeemed",
      };
      const q = this.searchAdvPayments.toLowerCase();
      return list.filter((p) => {
        const statusLabel = statusMap[p.ad_status] || "";
        return (
          statusLabel.toLowerCase().includes(q) ||
          (p.ad_cheque_no || "").toLowerCase().includes(q) ||
          String(p.advance_amount || "").includes(q)
        );
      });
    },

    paginatedPayments() {
      const start = (this.currentPaymentPage - 1) * this.perPaymentPage;
      return this.filteredPayments.slice(start, start + this.perPaymentPage);
    },
    totalPaymentPages() {
      return Math.ceil(this.filteredPayments.length / this.perPaymentPage) || 1;
    },

    paginatedAdvPayments() {
      const start = (this.currentAdvPaymentPage - 1) * this.perAdvPaymentPage;
      return this.filteredAdvPayments.slice(
        start,
        start + this.perAdvPaymentPage,
      );
    },
    totalAdvPaymentPages() {
      return (
        Math.ceil(this.filteredAdvPayments.length / this.perAdvPaymentPage) || 1
      );
    },

    canProceedToPayment() {
      if (this.selectedDealerType === 1) {
        return (
          this.selectedDealerGroup &&
          this.selectedDealerGroup.group_id &&
          this.selectedInvoices.length > 0
        );
      } else {
        return (
          this.selectedRoute &&
          this.selectedRoute.route_id &&
          this.selectedDealer &&
          this.selectedDealer.profile_id &&
          this.selectedInvoices.length > 0
        );
      }
    },

    multiselectOptionDealerGroup() {
      return [this.allDealerGroupsOption, ...this.filteredDealerGroups];
    },

    allDueSelected() {
      const selectableInvoices =
        this.invoiceActionMode === "payment"
          ? this.filteredInvoices.filter(
              (inv) => parseFloat(inv.due_amount || 0) > 0
            )
          : this.filteredInvoices;

      if (selectableInvoices.length === 0) return false;

      const selectedNos = new Set(
        this.selectedInvoices.map((i) => i.invoices_no)
      );

      return selectableInvoices.every((inv) =>
        selectedNos.has(inv.invoices_no)
      );
    },

    // FIX: Group by profile_id (unique dealer ID) instead of business_name (can collide).
    // Each group now carries dealerId so the template and the child modal both use the same key.
    groupedInvoicesByDealer() {
      const map = this.filteredInvoices.reduce((acc, invoice) => {
        // Use profile_id as the unique key; fall back to business_name only for display
        const dealerId = invoice.profile_id || invoice.dealer_id || "unknown";
        if (!acc[dealerId]) {
          acc[dealerId] = {
            dealerId,
            dealerName:
              invoice.business_name ||
              invoice.business_display_name ||
              "Unknown Dealer",
            invoices: [],
          };
        }
        acc[dealerId].invoices.push(invoice);
        return acc;
      }, {});

      return Object.values(map);
    },

    selectableInvoices() {
      return this.filteredInvoices.filter(
        (inv) => parseFloat(inv.due_amount || 0) > 0
      );
    },
  },

  watch: {
    selectedDealerType(newVal) {
      this.selectedRoute = this.allRoutesOption;
      this.selectedDealer = this.allDealersOption;
      this.selectedDealerGroup = this.allDealerGroupsOption;
      if (newVal === 1) {
        this.loadDealerGroups();
      }
    },

    selectedRoute(newVal) {
      if (newVal) {
        this.successmessage = "";
        this.loadDealerListByRoute();
      }
    },

    selectedDealerGroup(newVal) {
      if (newVal?.group_id) {
        this.loadDealerListByGroup();
      }
    },

    selectedDealer() {
      this.loadAdvancePayments();
    },

    from_date() {
    },
    to_date() {
    },
    selectedPayMethod() {
      this.resetPopup();
    },

    showEditModal(newVal) {
      this.hideScroll(newVal);
    },
    showAdvancePaymentModal(newVal) {
      this.hideScroll(newVal);
    },
    showSettleInvoicePaymentModal(newVal) {
      this.hideScroll(newVal);
    },
    showModal(newVal) {
      this.hideScroll(newVal);
    },
    showPopup(newVal) {
      this.hideScroll(newVal);
    },
    showBottomSheet(newVal) {
      this.hideScroll(newVal);
    },
    showADBottomSheet(newVal) {
      this.hideScroll(newVal);
    },
    showConfirmPopup(newVal) {
      this.hideScroll(newVal);
    },

    // selectedTab(newVal) {
    //   if (newVal) {
    //     this.editingRowIndex = null;
    //     this.editingADPaymentRowIndex = null;
    //   }
    // },

    selectedTab(newVal) {
      if (newVal) {
        this.editingRowIndex = null;
        this.editingADPaymentRowIndex = null;
        this.selectedPaymentIds = [];
      }
    },

    searchPayments() {
      this.currentPaymentPage = 1;
      this.selectedPaymentIds = [];
    },

    showBulkPaymentCancelSheet(newVal) {
      this.hideScroll(newVal);
    },

    selectedBank(newVal) {
      if (newVal) {
        this.successmessage = "";
        this.selectedBranch = "";
        this.loadBankBranchList();
      }
    },
  },

  created() {
    this.loadRouteList();
    this.loadDealerGroups();
  },

  mounted() {
    this.performSearch();
    document.addEventListener("click", this.closeInfoTooltip);
    window.addEventListener("scroll", this.closeInfoTooltip, true);
  },

  beforeUnmount() {
    document.removeEventListener("click", this.closeInfoTooltip);
    window.removeEventListener("scroll", this.closeInfoTooltip, true);
  },

  methods: {
    toggleInfoTooltip(event) {
      if (this.showInfoTooltip) {
        this.showInfoTooltip = false;
        return;
      }
      const rect = event.currentTarget.getBoundingClientRect();
      this.tooltipTop = rect.bottom + window.scrollY + 6;
      this.tooltipLeft = Math.max(10, rect.left + window.scrollX - 15);
      this.showInfoTooltip = true;
    },

    closeInfoTooltip(e) {
      if (this.showInfoTooltip) {
        if (e && e.target && e.target.closest && e.target.closest(".info-icon")) {
          return;
        }
        this.showInfoTooltip = false;
      }
    },

    async loadDealerGroups() {
      try {
        const response = await getDealerGroups(this.profileId, this.token);
        this.dealerGroupList = response.data?.data || [];
        this.filteredDealerGroups = [...this.dealerGroupList];
      } catch (error) {
        console.error("Error loading dealer groups:", error);
      }
    },

    filterDealerGroups(query) {
      const q = (query || "").toLowerCase();
      this.filteredDealerGroups = this.dealerGroupList.filter((g) =>
        (g.group_name || "").toLowerCase().includes(q),
      );
    },

    hideScroll(newVal) {
      document.body.style.overflow = newVal ? "hidden" : "";
    },

    openAdvancePaymentPrint(ad_payment) {
      this.selectedAdvancePayment = ad_payment;
      this.showAdvancePaymentPrintModal = true;
    },

    closeAdvancePaymentPrintModal() {
      this.showAdvancePaymentPrintModal = false;
      this.selectedAdvancePayment = null;
    },

    showAdvancePaymentDetails(ad_payment) {
      this.selectedAdvancePayment = ad_payment;
      this.showAdvancePaymentModal = true;
    },

    closeAdvancePaymentDetails() {
      this.showAdvancePaymentModal = false;
    },

    editDetails(index) {
      this.editingRowIndex = index;
    },
    editAdDetails(index) {
      this.editingAdvRowIndex = index;
    },

    deleteADPaymentDetails(id) {
      useToast().info("Delete advance payment is not implemented.");
    },

    formatNumber(value) {
      if (value === null || value === undefined || value === "") return "0.00";
      const num = Number(value);
      if (Number.isNaN(num)) return "0.00";
      return num.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    formatDateTime(datetime) {
      if (!datetime) return "";
      const date = new Date(datetime);
      if (Number.isNaN(date.getTime())) return String(datetime);
      return date.toLocaleString("en-US", {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });
    },

    ShowStatus(value) {
      const statusMap = {
        1: "Pending",
        2: "Completed",
        3: "Cancelled",
        4: "Redeemed",
      };
      return statusMap[value] || statusMap[String(value)] || "Unknown";
    },

    cancelEdit() {
      this.editingRowIndex = null;
      this.editingADPaymentRowIndex = null;
    },

    async saveDetails(id, index) {
      const updatedInvoice = this.filteredPayments[index];
      this.saveButtonDisabled = true;
      try {
        await updateInvoicePaymentDetails(id, this.token, {
          status: updatedInvoice.status,
        });
        useToast().success("Invoice Payment Updated Successfully");
        this.performSearch();
        this.editingRowIndex = null;
      } catch (error) {
        console.error("Caught error while saving invoice:", error);
      } finally {
        this.saveButtonDisabled = false;
      }
    },

    editAdvDetails(index) {
      this.editingAdvRowIndex = index;
    },
    cancelAdvEdit() {
      this.editingAdvRowIndex = null;
    },

    async saveADPaymentDetails(id, index) {
      const updatedPayment = this.filteredAdvPayments[index];
      this.saveButtonDisabled = true;
      try {
        await updateAdvancePayment(id, this.token, {
          status: updatedPayment.ad_status,
        });
        useToast().success("Advance Payment Updated Successfully");
        this.performSearch();
        this.editingAdvRowIndex = null;
      } catch (error) {
        console.error("Caught error while saving advance payment:", error);
      } finally {
        this.saveButtonDisabled = false;
      }
    },

    async loadDealerListByRoute() {
      try {
        const route_id = parseInt(this.selectedRoute?.route_id || 0);
        const response = await getDealersByRoute(route_id, this.token);
        this.dealerList = response.data?.data || [];
        this.filteredDealers = [...this.dealerList];
        this.selectedDealer = this.allDealersOption;
      } catch (error) {
        console.error("Error loading Dealer list:", error);
      }
    },

    async loadDealerListByGroup() {
      try {
        const groupId = parseInt(this.selectedDealerGroup?.group_id || 0);
        const response = await getDealersByGroup(groupId, this.token);
        this.dealerList = response.data?.data || [];
        this.filteredDealers = [...this.dealerList];
        this.selectedDealer = this.allDealersOption;
      } catch (error) {
        console.error("Error loading Dealer list:", error);
      }
    },

    filterDealers(query) {
      const q = (query || "").toLowerCase();
      this.filteredDealers = this.dealerList.filter((dealer) =>
        (dealer.business_display_name || "").toLowerCase().includes(q),
      );
    },

    async loadRouteList() {
      try {
        const response = await fetchRouteListByLoginUser(
          this.profileId,
          this.token,
        );
        this.routeList = response.data?.data || [];
        this.filteredRoutes = [...this.routeList];
        this.selectedRoute = this.allRoutesOption;
      } catch (error) {
        console.error("Error fetching Routes:", error);
      }
    },

    filterRoutes(query) {
      const q = (query || "").toLowerCase();
      this.filteredRoutes = this.routeList.filter((route) =>
        (route.route_name || "").toLowerCase().includes(q),
      );
    },

    // FIX: For group mode, fetch advance payments for every unique dealer in the
    // returned invoice list, not just the optionally-selected single dealer.
    async loadAdvancePayments() {
      try {
        const payload = {
          profileId: this.profileId,
          dealerTypeId: this.selectedDealerType ?? "",
          groupId: this.selectedDealerGroup?.group_id ?? "",
          routeId: this.selectedRoute?.route_id ?? "",
          dealerId: this.selectedDealer?.profile_id ?? "",
          startDate: this.from_date ?? "",
          endDate: this.to_date ?? "",
        };
        const response = await getAdvancePaymentDetails(payload, this.token);
        const dataList = response.data?.data || [];
        this.advancePaymentList = dataList.map((p) => ({
          ...p,
          ad_business_name: p.dealer_name || p.ad_business_name,
          advance_amount: p.amount || p.advance_amount,
          advance_balance: p.balance || p.advance_balance,
          ad_paid_at: p.paid_at || p.ad_paid_at,
          ad_status: String(p.status || p.ad_status),
          ad_pay_method: p.pay_method || p.ad_pay_method,
          advance_payment_id: p.id || p.advance_payment_id,
          ad_cheque_no: p.cheque_no || p.ad_cheque_no,
          ad_bank_acc_no: p.distributor_account || p.ad_bank_acc_no,
          ad_card_type: p.card_type || p.ad_card_type,
          ad_card_last4_digits: p.card_last4_digits || p.ad_card_last4_digits,
          ad_mobile_payment_type: p.mobile_payment_type || p.ad_mobile_payment_type,
          ad_mobile_provider: p.mobile_provider || p.ad_mobile_provider,
          ad_online_gateway: p.online_gateway || p.ad_online_gateway,
        }));
      } catch (error) {
        console.error("Error fetching advance payments:", error);
      }
    },

    hasBeenUsed(adPayment) {
      return (
        parseFloat(adPayment.advance_balance) <
        parseFloat(adPayment.advance_amount)
      );
    },

    async performSearch() {
      if (
        this.selectedDealerType === 1 &&
        (!this.selectedDealerGroup || !this.selectedDealerGroup.group_id)
      ) {
        const toast = useToast();
        toast.error("Please select a dealer group.");
        return;
      }

      this.selectedInvoices = [];
      this.selectedPaymentIds = [];
      this.selectedTab = "invoices";
      this.editingRowIndex = null;
      this.editingADPaymentRowIndex = null;
      this.invoicePaymentList = [];
      this.advancePaymentList = [];
      this.rawInvoicePayments = [];
      this.flattenedPayments = [];
      this.total_excess_amount = 0;
      this.total_due_amount = 0;

      try {
        const payload = {
          profile_id: this.profileId,
          dealer_id: this.selectedDealer?.profile_id ?? "",
          route_id: this.selectedRoute?.route_id ?? "",
          dealer_group_id: this.selectedDealerGroup?.group_id ?? "",
          dealer_type: this.selectedDealerType ?? "",
          from_date: this.from_date,
          to_date: this.to_date,
        };

        this.loading = true;
        this.searchPerformed = false;

        const response = await invoicePaymentDetails(payload, this.token);

        // FIX: Ensure each invoice retains profile_id and business_name from the API.
        // If the API returns them under different keys, normalise here so downstream
        // grouping (both in this component and in the settle popup) always works.
        this.invoicePaymentList = (response.data?.data || []).map(
          (invoice) => ({
            ...invoice,
            // Normalise: guarantee profile_id is present
            profile_id: invoice.profile_id || invoice.dealer_id || "",
            // Normalise: guarantee business_name is present
            business_name:
              invoice.business_name || invoice.business_display_name || "",
            original_due_amount: invoice.due_amount,
          }),
        );

        this.advancePaymentList = response.data?.advance_payments || [];

        this.total_excess_amount = this.advancePaymentList
          .filter((p) => p.ad_status === "1" || p.ad_status === "2")
          .reduce((sum, p) => sum + parseFloat(p.advance_amount || 0), 0);

        this.rawInvoicePayments = response.data?.invoice_payments || [];
        if (Array.isArray(this.rawInvoicePayments)) {
          let flag = 0;
          this.flattenedPayments = this.rawInvoicePayments.flatMap((group) => {
            const groupWithFlag = (group.payments || []).map((payment) => ({
              invoice_no: group.invoice_no,
              payment_method: payment.payment_method,
              cheque_no: payment.cheque_no,
              bank_acc_no: payment.bank_acc_no,
              advance_pay_method: payment.advance_pay_method,
              advance_amount: payment.advance_amount,
              card_type: payment.card_type,
              card_last4_digits: payment.card_last4_digits,
              mobile_payment_type: payment.mobile_payment_type,
              mobile_provider: payment.mobile_provider,
              online_gateway: payment.online_gateway,
              amount: payment.amount,
              paid_at: payment.paid_at,
              status: payment.status,
              payment_id: payment.payment_id,
              flag,
            }));
            flag = flag === 0 ? 1 : 0;
            return groupWithFlag;
          });
        } else {
          this.flattenedPayments = [];
        }

        this.total_due_amount = response.data?.total_due_amount || 0;
        this.currentPage = 1;
        this.currentPaymentPage = 1;
        this.currentAdvPaymentPage = 1;

        // Load advance payments AFTER invoicePaymentList is populated so
        // loadAdvancePayments() can read the unique dealer IDs from it.
        await this.loadAdvancePayments();

        this.searchPerformed = true;
      } catch (error) {
        console.log("Error fetching invoice payment list:", error);
      } finally {
        this.loading = false;
      }
    },

    //for bulk cancel
    isPaymentCancellable(payment) {
      if (!payment) return false;

      return payment.payment_id && String(payment.status) !== "3";
    },

    toggleVisiblePaymentSelection() {
      const visibleIds = this.cancellablePaginatedPayments.map((payment) =>
        String(payment.payment_id),
      );

      const selectedIds = new Set(this.selectedPaymentIds.map(String));

      if (this.allVisiblePaymentsSelected) {
        visibleIds.forEach((id) => selectedIds.delete(id));
      } else {
        visibleIds.forEach((id) => selectedIds.add(id));
      }

      this.selectedPaymentIds = Array.from(selectedIds);
    },

    openBulkPaymentCancelPopup(mode) {
      const toast = useToast();

      this.bulkPaymentCancelMode = mode;

      const ids = this.bulkPaymentIdsToCancel();

      if (ids.length === 0) {
        toast.warning("No invoice payments available to cancel.");
        return;
      }

      this.bulkCancelRemark = "";
      this.bulkCancelRemarkError = false;
      this.showBulkPaymentCancelSheet = true;
    },

    closeBulkPaymentCancelSheet() {
      this.showBulkPaymentCancelSheet = false;
      this.bulkCancelRemark = "";
      this.bulkCancelRemarkError = false;
      this.bulkCancelLoading = false;
    },

    validateBulkCancelRemark() {
      this.bulkCancelRemarkError = !this.bulkCancelRemark.trim();
    },

    bulkPaymentIdsToCancel() {
      return this.selectedPaymentIds.map((id) => Number(id));
    },

    async confirmBulkPaymentCancel() {
      const toast = useToast();

      if (!this.bulkCancelRemark.trim()) {
        this.bulkCancelRemarkError = true;
        return;
      }

      const paymentIds = this.bulkPaymentIdsToCancel();

      if (paymentIds.length === 0) {
        toast.warning("No invoice payments selected.");
        return;
      }

      const payload = {
        payment_ids: paymentIds,
        payment_canceled_by: this.profileId,
        status: 3,
        cancel_remark: this.bulkCancelRemark,
      };

      try {
        this.bulkCancelLoading = true;

        const response = await bulkCancelInvoicePayments(payload, this.token);

        if (response.data?.status === "success") {
          toast.success(
            response.data?.message ||
              "Invoice payments cancelled successfully.",
          );

          this.closeBulkPaymentCancelSheet();
          this.selectedPaymentIds = [];
          this.performSearch();
        } else {
          toast.error(
            response.data?.message || "Failed to cancel invoice payments.",
          );
        }
      } catch (error) {
        console.error("Error bulk cancelling invoice payments:", error);
        toast.error("Error cancelling invoice payments.");
      } finally {
        this.bulkCancelLoading = false;
      }
    },

    openCancelPopup(id, index) {
      this.selectedInvoiceId = id;
      this.selectedInvoiceIndex = index;
      this.showBottomSheet = true;
    },

    openCancelPopupADPayments(id, index) {
      this.selectedPaymentId = id;
      this.selectedPaymentIndex = index;
      this.showADBottomSheet = true;
    },

    closeBottomSheet() {
      this.showBottomSheet = false;
      this.showADBottomSheet = false;
      this.cancelRemark = "";
      this.remarkError = false;
    },

    validateRemark() {
      this.remarkError = !this.cancelRemark.trim();
    },

    async confirmCancel(id) {
      if (!this.cancelRemark.trim()) {
        this.remarkError = true;
        return;
      }
      const payload = {
        payment_canceled_by: this.profileId,
        status: "3",
        cancel_remark: this.cancelRemark,
      };
      try {
        await cancelInvoicePayment(id, this.token, payload);
        useToast().success("Invoice Payment cancelled successfully.");
        this.closeBottomSheet();
        this.performSearch();
      } catch (error) {
        console.error("Caught error while cancelling invoice payment:", error);
      }
    },

    async confirmPaymentCancel(id) {
      if (!this.cancelRemark.trim()) {
        this.remarkError = true;
        return;
      }
      const payload = {
        canceled_by: this.profileId,
        status: "3",
        cancel_remark: this.cancelRemark,
      };
      try {
        await cancelAdvancePayment(id, this.token, payload);
        useToast().success("Advance Payment cancelled successfully.");
        this.closeBottomSheet();
        this.performSearch();
      } catch (error) {
        console.error("Caught error while cancelling advance payment:", error);
      }
    },

    showInvoiceDetails(invoice) {
      this.selectedInvoiceNo = invoice;
      this.isMultiInvoiceView = false;
      this.showModal = true;
    },

    handleProceedToPayment() {
      const toast = useToast();
      const isGroup = this.selectedDealerType === 1;

      if (!this.selectedDealerType) {
        toast.warning(
          "Please select a dealer or dealer group before proceeding.",
        );
        return;
      }
      if (isGroup) {
        if (!this.selectedDealerGroup?.group_id) {
          toast.warning("Please select a dealer group before proceeding.");
          return;
        }
      } else {
        if (!this.selectedRoute?.route_id) {
          toast.warning("Please select a route before proceeding.");
          return;
        }
        if (!this.selectedDealer?.profile_id) {
          toast.warning("Please select a dealer before proceeding.");
          return;
        }
      }
      if (this.selectedInvoices.length === 0) {
        toast.warning("Please select at least one invoice to proceed.");
        return;
      }
      this.settleDue();
    },

    toggleSelectAllDue() {
      if (this.allDueSelected) {
        this.selectedInvoices = [];
        return;
      }

      if (this.invoiceActionMode === "payment") {
        // Payment: select only invoices that have a due amount
        this.selectedInvoices = this.filteredInvoices.filter(
          (inv) => parseFloat(inv.due_amount || 0) > 0
        );
      } else {
        // Print: select ALL invoices, including fully-paid/completed invoices
        this.selectedInvoices = [...this.filteredInvoices];
      }
    },

    // FIX: Use invoices_no as the unique key for selection matching (same as checkbox v-model).
    isDealerAllSelected(dealerInvoices) {
      const due = dealerInvoices.filter(
        (inv) => parseFloat(inv.due_amount) > 0,
      );
      if (due.length === 0) return false;
      const selectedNos = new Set(
        this.selectedInvoices.map((i) => i.invoices_no),
      );
      return due.every((inv) => selectedNos.has(inv.invoices_no));
    },

    toggleDealerSelection(dealerInvoices) {
      const due = dealerInvoices.filter(
        (inv) => parseFloat(inv.due_amount) > 0,
      );
      const selectedNos = new Set(
        this.selectedInvoices.map((i) => i.invoices_no),
      );
      if (this.isDealerAllSelected(dealerInvoices)) {
        const dueNos = new Set(due.map((i) => i.invoices_no));
        this.selectedInvoices = this.selectedInvoices.filter(
          (i) => !dueNos.has(i.invoices_no),
        );
      } else {
        const toAdd = due.filter((inv) => !selectedNos.has(inv.invoices_no));
        this.selectedInvoices = [...this.selectedInvoices, ...toAdd];
      }
    },

    dealerTotalDue(dealerInvoices) {
      return dealerInvoices.reduce(
        (sum, inv) => sum + parseFloat(inv.due_amount || 0),
        0,
      );
    },

    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },
    nextPaymentPage() {
      if (this.currentPaymentPage < this.totalPaymentPages)
        this.currentPaymentPage++;
    },
    prevPaymentPage() {
      if (this.currentPaymentPage > 1) this.currentPaymentPage--;
    },
    nextAdvPaymentPage() {
      if (this.currentAdvPaymentPage < this.totalAdvPaymentPages)
        this.currentAdvPaymentPage++;
    },
    prevAdvPaymentPage() {
      if (this.currentAdvPaymentPage > 1) this.currentAdvPaymentPage--;
    },

    closePopup() {
      this.showPopup = false;
      this.selectedPayMethod = "";
      this.amount = "";
      this.chequeNo = "";
      this.selectedBank = "";
      this.selectedBranch = "";
      this.refCode = "";
    },

    resetPopup() {
      this.chequeNo = "";
      this.selectedBank = "";
      this.selectedBranch = "";
      this.refCode = "";
    },

    resetSection() {
      this.searchPerformed = false;
      // this.selectedInvoices = [];
      this.selectedInvoices = [];
      this.selectedPaymentIds = [];
      this.currentPage = 1;
      this.currentPaymentPage = 1;
      this.currentAdvPaymentPage = 1;
      this.total_due_amount = 0;
      this.searchFilter = "";
      this.editingRowIndex = null;
      this.editingADPaymentRowIndex = null;
      // FIX: Reset expandedDealers on section reset
      this.expandedDealers = {};
    },

    editInvoicePaymentDetails(invoice_no) {
      this.selectedInvoiceNo = invoice_no;
      this.showEditModal = true;
    },

    newAdvance(invoice_no) {
      if (!this.selectedDealer || !this.selectedDealer.profile_id) {
        useToast().warning("Please select a dealer to add an advance payment.");
        return;
      }
      this.selectedInvoiceNo = invoice_no;
      this.showAdvancePaymentModal = true;
    },

    settleDue() {
      this.showSettleInvoicePaymentModal = true;
    },

    closeEditInvoiceModal() {
      this.showEditModal = false;
      this.performSearch();
    },

    closeAdvancePaymentModal() {
      this.showAdvancePaymentModal = false;
      this.performSearch();
    },

    closeSettleInvoicePaymentModal() {
      this.showSettleInvoicePaymentModal = false;
      this.performSearch();
    },

    closeModal() {
      this.showModal = false;
    },

    // FIX: Toggle expand keyed by dealerId, not dealerName
    toggleDealerExpand(dealerId) {
      this.expandedDealers = {
        ...this.expandedDealers,
        [dealerId]: !this.expandedDealers[dealerId],
      };
    },

    isCashSaleDealer(entity) {
      if (!entity) return false;
      const name = (
        typeof entity === "string"
          ? entity
          : entity.business_name || entity.business_display_name || ""
      ).toUpperCase();
      return name.includes("CASH SALE");
    },

    handlePrintInvoices() {
      if (this.selectedInvoices.length === 0) {
        useToast().warning("Please select at least one invoice to print.");
        return;
      }

      this.selectedInvoiceNos = this.selectedInvoices.map(
        invoice => invoice.invoices_no
      );
      this.isMultiInvoiceView = true;

      this.showModal = true;
    }
  },
};
</script>

<style scoped>
/* Bottom Sheet Styles */
.bottom-sheet-overlay {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 1100;
}

.bottom-sheet {
  background: #fff;
  width: 100%; /* Make it full width */
  padding: 20px;
  border-radius: 10px 10px 0 0;
  box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.1);
  position: fixed;
  bottom: 0;
  left: 0;
  max-width: 100%; /* Ensure it stretches across all screen sizes */
}

.bottom-sheet h3 {
  margin-bottom: 20px;
  text-align: left;
}

.bottom-sheet textarea {
  width: 100%;
  height: 100px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: none;
  margin-bottom: 10px;
}

.bottom-sheet textarea:focus {
  border-color: #1c1f23;
  outline: none;
}

.bottom-sheet-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.btn-exit {
  background-color: #ccc;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.btn-cancel {
  background-color: #f44336;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.btn-exit:hover {
  background-color: #999;
}

.btn-cancel:hover {
  background-color: #d32f2f;
}

.error-message {
  color: red;
  font-size: 14px;
  margin-top: -5px;
}

.disabled-icon {
  color: #ccc !important;
  cursor: not-allowed !important;
  opacity: 0.6;
}

.status-pending {
  background-color: #ffc107; /* Yellow color */
  color: #ffffff; /* White text */
  padding: 5px 10px;
  border-radius: 5px;
}

.status-completed {
  background-color: #069e27;
  color: #fff;
  border-radius: 4px;
}

.status-cancelled {
  background-color: red;
  color: #fff;
  border-radius: 4px;
}
.status-redeemed {
  background-color: #1b6cb4;
  color: #fff;
  border-radius: 4px;
}

.status-label {
  padding: 5px 10px;
  border-radius: 3px;
  display: inline-block;
}

.fa-edit {
  cursor: pointer;
  transition: color 0.3s, transform 0.3s;
}
.fa-edit:hover {
  color: #0056b3;
  transform: scale(1.2);
}
.fa-edit:active {
  transform: scale(1.1);
}

.fa-eye {
  cursor: pointer;
  transition: color 0.3s, transform 0.3s;
}
.fa-eye:hover {
  color: #0056b3;
  transform: scale(1.2);
}
.fa-eye:active {
  transform: scale(1.1);
}

.fa-times-circle-o {
  cursor: pointer;
  transition: color 0.3s, transform 0.3s;
}
.fa-times-circle-o:hover {
  color: #0056b3;
  transform: scale(1.2);
}
.fa-times-circle-o:active {
  transform: scale(1.1);
}

.styled-bank-dropdown .multiselect__option {
  display: flex;
  flex-direction: column;
  padding: 8px;
  font-size: 14px;
}

.styled-bank-dropdown .multiselect__option span {
  color: #666;
  font-size: 12px;
}

.highlight-row {
  background-color: #f5f5f5 !important;
}

html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
  background-color: #f0f0f0;
}

.chip-container {
  display: flex;
  gap: 15px;
  margin-bottom: 30px;
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 50px;
  border: 1px solid transparent;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: #f1f5f9;
  color: #64748b;
  outline: none;
}

.chip .chip-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 6px;
  border-radius: 12px;
  background-color: rgba(0,0,0,0.1);
  font-size: 11px;
  font-weight: 700;
}

.chip:hover {
  background-color: #e2e8f0;
}

.chip.chip-blue {
  background-color: #eff6ff;
  color: #3b82f6;
  border-color: #dbeafe;
}
.chip.chip-blue .chip-badge {
  background-color: #bfdbfe;
  color: #1e3a8a;
}
.chip.chip-blue.active {
  background-color: #3b82f6;
  color: #ffffff;
  border-color: #2563eb;
}
.chip.chip-blue.active .chip-badge {
  background-color: #ffffff;
  color: #1d4ed8;
}

.chip.chip-green {
  background-color: #f0fdf4;
  color: #22c55e;
  border-color: #dcfce7;
}
.chip.chip-green .chip-badge {
  background-color: #bbf7d0;
  color: #14532d;
}
.chip.chip-green.active {
  background-color: #22c55e;
  color: #ffffff;
  border-color: #16a34a;
}
.chip.chip-green.active .chip-badge {
  background-color: #ffffff;
  color: #15803d;
}

.chip.chip-amber {
  background-color: #fffbeb;
  color: #d97706;
  border-color: #fef3c7;
}
.chip.chip-amber .chip-badge {
  background-color: #fde68a;
  color: #92400e;
}
.chip.chip-amber.active {
  background-color: #f59e0b;
  color: #ffffff;
  border-color: #d97706;
}
.chip.chip-amber.active .chip-badge {
  background-color: #ffffff;
  color: #b45309;
}

.card .table-responsive {
  overflow-x: visible !important;
  -webkit-overflow-scrolling: auto !important;
}

.card {
  padding: 20px;
  margin-bottom: 40px !important;
}

.project-cards .tab-content {
  margin-bottom: 0px;
}

.cards {
  display: flex;
  gap: 100px;
}

.req {
  color: red;
  margin-left: 5px;
}

.searchbar {
  flex: 1 !important;
  max-width: 45% !important;
  margin-bottom: 1rem;
}

/* Popup modal */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  border-radius: 5px !important;
}

.popup-content {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  width: 90%;
  max-width: 100%;
  max-height: 80vh; /* Set a maximum height */
  overflow-y: auto; /* Enable vertical scrolling */
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #000;
  transition: color 0.3s;
}

.popup-content h3 {
  margin-top: 0;
}

.popup-content ul {
  padding-left: 20px;
}

.popup-content ul li {
  margin-bottom: 10px;
}

.popup-table {
  max-height: 300px;
  overflow-y: auto;
}

.invoice-popup-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
  margin-top: 30px;
}

.invoice-popup-table th,
.invoice-popup-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.invoice-popup-table th {
  background-color: #f2f2f2;
  font-weight: bold;
}

.dropdown-container {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 15px;
  width: 100%;
  margin-bottom: 0;
}

.dropdown-container-popup {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /*grid-template-columns: 60% 40%;*/
  gap: 15px;
  width: 100%;
  justify-content: center;
  padding: 30px;
}

.dropdown-item {
  flex: 1;
  min-width: 150px;
}

.details-container {
  display: grid;
  grid-template-columns: 10% 90%;
  gap: 15px;
  width: 100%;
  justify-content: center;
  margin-bottom: 20px;
}

.details-container .dropdown-item {
  margin-left: 10px;
  max-width: 30%;
}

.details-container-popup {
  display: grid;
  grid-template-columns: 10% 90%;
  gap: 15px;
  width: 100%;
  justify-content: center;
  margin-bottom: 20px;
}

.details-container-popup .dropdown-item {
  margin-left: 10px;
  max-width: 50%;
}

.payment {
  margin-top: 30px;
}

label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 14px;
}

select {
  width: 100%; /**/
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  transition: border-color 0.3s, box-shadow 0.3s;
}

/* =========================================================
   FINANCIAL SUMMARY — SITE-MATCHED FLAT CARDS
======================================================== */

.financial-summary-card {
  --summary-color: #52667d;
  --summary-soft: #f3f6f9;
  --summary-bg-start: #ffffff;
  --summary-bg-end: #ffffff;
  --summary-border: transparent;

  flex: 1;
  min-width: 0;
  min-height: 100px;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 10px;
  background: linear-gradient(135deg, var(--summary-bg-start) 0%, var(--summary-bg-end) 100%);
  border: 1px solid var(--summary-border);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.financial-summary-card:hover {
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.summary-card-heading {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.summary-icon {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  border-radius: 8px;
  background-color: var(--summary-soft);
  color: var(--summary-color);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}

.summary-label {
  min-width: 0;
  color: #495057;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.01em;
}

.summary-value {
  display: flex;
  align-items: baseline;
  gap: 6px;
  min-width: 0;
  margin-top: 15px;
  white-space: nowrap;
}

.summary-value small {
  color: #64748b;
  font-size: 14px;
  font-weight: 600;
}

.summary-value strong {
  min-width: 0;
  overflow: hidden;
  color: #1f2937;
  font-size: 26px;
  font-weight: 700;
  line-height: 1.15;
  letter-spacing: -0.01em;
  text-overflow: ellipsis;
}

.summary-due {
  --summary-color: #ef4444;
  --summary-soft: #fef2f2;
  --summary-bg-start: #ffffff;
  --summary-bg-end: #fff1f2;
  --summary-border: #fecaca;
}

.summary-paid {
  --summary-color: #22c55e;
  --summary-soft: #f0fdf4;
  --summary-bg-start: #ffffff;
  --summary-bg-end: #f0fdf4;
  --summary-border: #bbf7d0;
}


input[type="date"] {
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  transition: border-color 0.3s, box-shadow 0.3s;
}
input[type="number"] {
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  transition: border-color 0.3s, box-shadow 0.3s;
}

input[type="text"] {
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  transition: border-color 0.3s, box-shadow 0.3s;
}

select:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
  outline: none;
}

input:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
  outline: none;
}

.fullscreen-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5); /* semi-transparent overlay */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.spinner {
  width: 60px;
  height: 60px;
  border: 5px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 1s ease infinite;
}

.loading-spinner {
  font-size: 18px;
  text-align: center;
  margin-top: 20px;
  color: #007bff;
}

.pagination-container {
  display: flex;
  justify-content: right;
  align-items: center;
  margin-top: 30px;
  width: 100%;
}

.table-responsive {
  margin-top: 30px;
}

.checkbox {
  width: 15px;
  height: 15px;
  border: 2px solid #007bff;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #007bff;
  background-color: white;
  border-radius: 4px;
  transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
  position: relative;
  margin-right: 10px;
}

:deep(.multiselect__spinner::before, .multiselect__spinner::after) {
  border-color: #007bff transparent transparent;
}

:deep(.multiselect__tag) {
  background: #007bff;
}

:deep(.multiselect__option--highlight) {
  background: #007bff;
}

:deep(.multiselect__option--highlight::after) {
  background: #007bff;
}

:deep(.multiselect__option--selected.multiselect__option--highlight) {
  background: #007bff;
}

:deep(.multiselect__option--selected.multiselect__option--highlight::after) {
  background: #007bff;
}

:deep(.multiselect__option--group-selected.multiselect__option--highlight) {
  background: #007bff;
}

:deep(
    .multiselect__option--group-selected.multiselect__option--highlight::after
  ) {
  background: #007bff;
}

.due-payments {
  background-color: #fbe9eb !important;
  border: 1px solid #dc3545;
}

.total-amount {
  background-color: #e0ecff;
}

.total-paid {
  background-color: #e5f4e9;
  border: 1px solid #28a745;
}

.summary-card {
  color: #212529;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease;
  width: 25%;
}

.card.summary-card {
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.small-card-body {
  padding: 10px 15px;
  min-height: 80px; /* You can adjust this */
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.card .card-body {
  padding: 0px;
  background-color: transparent;
}

.text-dark {
  font-size: 20px;
}

.payment-selection-info {
  font-size: 14px;
  color: #333;
}

.payment-pagination {
  width: auto !important;
  margin-top: 0 !important;
  justify-content: flex-end !important;
}

.border-red {
  border-color: red !important;
}

.payment-footer-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 30px;
  margin-bottom: 40px;
}

.payment-selection-info {
  font-size: 14px;
  color: #333;
}

.payment-pagination-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
  flex-wrap: wrap;
}

.payment-pagination {
  width: auto !important;
  margin-top: 0 !important;
  justify-content: flex-end !important;
}

.modern-searchbar-container {
  width: 100%;
  max-width: 100%;
}

.modern-searchbar {
  position: relative;
  display: flex;
  align-items: center;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 4px 16px;
  transition: all 0.3s ease;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
}

.modern-searchbar.searchbar-blue:focus-within {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.modern-searchbar.searchbar-green:focus-within {
  border-color: #22c55e;
  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.1);
}

.modern-searchbar.searchbar-amber:focus-within {
  border-color: #f59e0b;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.1);
}

.modern-searchbar .search-icon {
  color: #94a3b8;
  font-size: 14px;
  margin-right: 12px;
}

.modern-searchbar .modern-search-input {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
  width: 100%;
  font-size: 14px;
  color: #334155;
  background: transparent;
  padding: 4px 0;
  margin: 0;
}

.modern-searchbar .modern-search-input::placeholder {
  color: #94a3b8;
}

.table-scroll-container {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  padding-bottom: 80px; /* Space for the bottom action bar */
}

/* Edit Action Buttons */
.btn-action-accept, .btn-action-close {
  border-radius: 50%;
  width: 32px;
  height: 32px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  transition: all 0.2s ease;
}

.btn-action-accept {
  background-color: #d1e7dd;
  color: #0f5132;
}
.btn-action-accept:hover {
  background-color: #198754;
  color: #ffffff;
}

.btn-action-close {
  background-color: #f8d7da;
  color: #842029;
}
.btn-action-close:hover {
  background-color: #dc3545;
  color: #ffffff;
}

/* Modern Empty State */
.modern-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  background: #f8f9fa;
  border-radius: 12px;
  border: 1px dashed #ced4da;
  text-align: center;
  margin: 20px 0;
}
.modern-empty-state .empty-icon {
  font-size: 48px;
  color: #adb5bd;
  margin-bottom: 15px;
}
.modern-empty-state h5 {
  font-size: 18px;
  font-weight: 600;
  color: #495057;
  margin-bottom: 8px;
}
.modern-empty-state p {
  font-size: 14px;
  color: #6c757d;
  margin-bottom: 0;
}
.modern-empty-state .add-link {
  color: #007bff;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
}
.modern-empty-state .add-link:hover {
  color: #0056b3;
  text-decoration: underline;
}

.table-compact {
  margin-bottom: 0 !important;
}

.table-compact th, .table-compact td {
  padding: 0.5rem 0.75rem !important;
  font-size: 0.85rem !important;
  vertical-align: middle !important;
}

.table-compact thead th {
  background-color: #f8fafc !important;
  color: #475569 !important;
  font-weight: 600 !important;
  border-bottom: none !important;
  position: sticky !important;
  top: 0 !important;
  z-index: 10 !important;
  box-shadow: 0 1px 0 #e2e8f0 !important; 
}

/* Modify status badge */
.status-label {
  padding: 2px 6px !important;
  font-size: 0.7rem !important;
  border-radius: 4px !important;
  font-weight: 600;
}
/* Bottom action bar */
.bottom-action-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background-color: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  margin-top: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

.bottom-action-bar.justify-content-end {
  justify-content: flex-end;
}

.bottom-action-bar .info-section {
  display: flex;
  flex-direction: column;
}

.bottom-action-bar .info-label {
  font-size: 0.85rem;
  color: #64748b;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.bottom-action-bar .info-value {
  font-size: 1.25rem;
  font-weight: 700;
  color: #0f172a;
  margin-top: 4px;
}

.bottom-action-bar .btn-action {
  padding: 10px 24px;
  font-weight: 600;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.card {
  min-height: calc(100vh - 120px);
}

.invoice-action-switch {
  display: inline-flex;
  align-items: center;
  padding: 4px;
  background: #f1f3f5;
  border: 1px solid #d9dee3;
  border-radius: 10px;
  gap: 4px;
}

.invoice-action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-width: 115px;
  padding: 8px 16px;
  border: none;
  border-radius: 7px;
  background: transparent;
  color: #6c757d;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.invoice-action-btn:hover {
  background: #ffffff;
  color: #343a40;
}

.invoice-action-btn.active {
  background: #ffffff;
  color: #212529;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}

.invoice-action-btn.print-btn.active {
  color: #0d6efd;
}

.invoice-action-btn.payment-btn.active {
  color: #198754;
}

.action-icon {
  font-size: 16px;
  line-height: 1;
}

.vat-verification-badge {
  color: #1a335e;
  font-size: 14px;
  margin-left: 2px;
  vertical-align: middle;
}

.info-icon {
  color: #007bff;
  cursor: pointer;
  font-size: 13px;
  margin-left: 6px;
  vertical-align: middle;
  transition: color 0.2s, transform 0.2s;
}

.info-icon:hover {
  color: #0056b3;
  transform: scale(1.2);
}

.header-info-tooltip {
  position: absolute;
  z-index: 999999;
  background-color: #ffffff;
  color: #334155;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 12px;
  line-height: 1.4;
  box-shadow: 0 10px 25px -3px rgba(0, 0, 0, 0.15), 0 4px 6px -4px rgba(0, 0, 0, 0.05);
  max-width: 270px;
  white-space: normal;
  pointer-events: auto;
  animation: tooltipFadeIn 0.15s ease-out;
}

@keyframes tooltipFadeIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.tooltip-arrow {
  position: absolute;
  top: -6px;
  left: 18px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #ffffff;
  filter: drop-shadow(0 -1px 1px rgba(0, 0, 0, 0.08));
}

.tooltip-content {
  display: flex;
  align-items: center;
  gap: 6px;
}

.vat-verification-badge-sm {
  color: #1a335e;
  font-size: 14px;
  margin: 0 2px;
  vertical-align: middle;
}
</style>